import React, { useState, useEffect } from 'react'
import PublicAppHeader from '../PublicAppHeader'
import { getFeatureList } from 'src/consumer/services/featureServices'
import { LoadingSpinner } from '../Loaders'
import { PublicListingComponentVarOne } from '../ListingPageComponentsAndHelpers/ListingPageComponents'
import { APP_CONSTANTS } from 'src/consumer/constants'
import { SEOComponent } from 'src/consumer/helpers/utilFunctions'
import useInfiniteScroll from 'react-infinite-scroll-hook'
import { getListItemsFromAssessmentList } from '../ListingPageComponentsAndHelpers/ListingPageHelpers'

export default function AssessmentListingPage() {
  const [pageLoading, setPageLoading] = useState(false)
  const [assessmentsList, setAssessmentsList] = useState()

  const [pageNumber, setPageNumber] = useState(1)
  const [hasNextPage, setHasNextPage] = useState(true)

  async function pageSetup() {
    setPageLoading(true)
    const resp = await getFeatureList('assessment')
    if (resp?.status === 200) {
      setAssessmentsList(resp?.data)
    }
    setPageLoading(false)
  }

  async function getNextAssessmentsPage() {
    const nextPageNumber = pageNumber + 1

    const resp = await getFeatureList('assessment', nextPageNumber)

    if (resp?.status === 200) {
      if (resp?.data && resp?.data?.length > 0) {
        setPageNumber(nextPageNumber)
        setAssessmentsList((prev) => [...prev, ...resp?.data])
      } else {
        // If there's no more data to load, set hasNextPage to false
        setHasNextPage(false)
      }
    } else {
      setHasNextPage(false)
    }
  }

  const [sentryRef] = useInfiniteScroll({
    hasNextPage,
    onLoadMore: getNextAssessmentsPage,
    rootMargin: '0px 0px 20px 0px',
  })

  useEffect(() => {
    pageSetup()
  }, [])

  return (
    <>
      <SEOComponent
        title="Understand Your Mental Health | AUMHUM"
        description="AUMHUM provides mental health tests to help you take control and improve your mental well-being. Start your journey today."
        image={APP_CONSTANTS.APP_LOGO_LINK}
        keywordsArr={['assessment', 'online', 'wellness']}
      />
      {pageLoading ? (
        <LoadingSpinner bgColor="#F5F5F599" dark />
      ) : (
        <>
          <PublicAppHeader config={{ showLinks: true }} />
          <PublicListingComponentVarOne
            heading="Quick Mental Health Check"
            description="Discover your mental health status with these fast and easy assessments."
            actionText="Start test"
            listItemsArray={getListItemsFromAssessmentList(assessmentsList)}
            sentryRef={sentryRef}
            hasNextPage={hasNextPage}
          />
        </>
      )}
    </>
  )
}
